import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  width: 100%;
  margin: 0;
  font-size: 24px;
  color: #1d1956;
  p {
    margin: 0 auto;
    width: 60%;
    padding: 2% 0;
  }
  h1 {
    margin: 0;
    color: #2610c5;
    font-size: 40px;
    line-height: 1;
    font-weight: normal;
    font-family: "DM Serif Display", serif;
  }

  h2 {
    margin: 0;
    font-weight: 500;
    font-size: 32px;
  }

  h3 {
    margin: 0;
    font-weight: normal;
    font-size: 32px;
  }

  hr {
    width: 8%;
    margin: 0 auto;
    border: 2px solid #2610c5;
  }

  @media (max-width: 800px) {
    font-size: 16px;
    p {
      margin: 0 auto;
      width: 90%;
    }
    h1 {
      font-size: 28px;
    }
    h2 {
      font-size: 24px;
    }
    h3 {
      font-size: 16px;
    }
  }
`;
export const AboutContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 5% 0;
  h1,
  p {
    margin-top: 3%;
  }
`;

export const ImagesContainer = styled.div`
  display: grid;
  width: 80%;
  grid-template-columns: 50% 50%;
  align-items: center;
  margin: 0 auto;
  margin-top: 3%;

  .leftImage {
    width: 100%;
  }
  @media (max-width: 800px) {
    width: 100%;
    display: block;

    .leftImage {
      display: none;
    }
  }
`;
export const GridImages = styled.div`
  margin: 0;
  display: grid;
  grid-template-columns: 50% 50%;
  img {
    width: 100%;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;
export const MobileImage = styled.img`
  display: none;
  width: 100%;
  @media (max-width: 800px) {
    display: block;
  }
`;
export const MiddleContainer = styled.div`
  background: #e5e5e5;
  position: relative;
  padding: 10% 0;

  @media (max-width: 800px) {
    padding: 30% 0;
    margin: 30% 0;
  }
`;

export const AboutOne = styled.img`
  position: absolute;
  left: 5%;
  width: 19%;
  bottom: -25%;
  @media (max-width: 800px) {
    display: none;
  }
`;
export const AboutTwo = styled.img`
  position: absolute;
  width: 19%;
  right: 5%;
  top: -25%;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const ContactContainer = styled.div`
  padding: 5% 0;
  margin: 0 auto;
  h2 {
    margin-bottom: 4%;
  }
  input,
  textarea {
    padding: 1%;
    border: 0.3px solid whitesmoke;
    box-shadow: 1px 1px 3px #aaaaaa;
    margin-bottom: 2%;
    width: 30%;
  }
  .submit {
    width: 10%;
    border-radius: 30px;
    border: none;
    padding: 1%;
    font-size: 16px;
    background: #2610c5;
    color: white;
    cursor: pointer;
  }
  @media (max-width: 800px) {
    input,
    textarea {
      width: 60%;
    }
    .submit {
      width: 20%;
    }
  }
`;

export const MobileOne = styled.img`
  display: none;
  @media (max-width: 800px) {
    position: absolute;
    width: 80%;
    top: -22%;
    left: 0;
    display: block;
  }
`;

export const MobileTwo = styled.img`
  display: none;
  @media (max-width: 800px) {
    width: 80%;
    right: 0;
    bottom: -22%;
    position: absolute;
    display: block;
  }
`;

export const CircleOne = styled.img`
  position: absolute;
  top: 160px;
  left: 0;
  @media (max-width: 800px) {
    display: none;
  }
`;
export const CircleTwo = styled.img`
  position: absolute;
  top: 140px;
  left: 2%;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const CircleFour = styled.img`
  position: absolute;
  top: 330px;
  right: 12%;
  @media (max-width: 800px) {
    display: none;
  }
`;
export const CircleFive = styled.img`
  position: absolute;
  left: 18%;
  top: 666px;
  width: 3%;
  @media (max-width: 800px) {
    display: none;
  }
`;
